import React, { Component } from 'react';

import { MaterialIcon, Text } from '../../atoms';

const mensurationData = "A mensuração do uso da água na indústria é o primeiro passo para o seu gerenciamento adequado. O acompanhamento de indicadores pode demonstrar como a empresa está caminhando sob a ótica da sustentabilidade, incluindo os reflexos das ações implementadas na bacia hidrográfica.";
const menagementData = "A segurança hídrica é essencial para a perenidade do negócio. Por isso o gerenciamento estratégico deve ir além do atendimento legal e melhoria do desempenho operacional. Avaliação de riscos e oportunidades com envolvimento da cadeia de valor e de atores externos pode trazer relevantes insights a sua empresa.";
const comunicationData = "Comunicar e engajar todas as partes interessadas (comunidade do entorno, fornecedores, funcionários, clientes, repartições públicas) é a terceira etapa de um projeto completo de gerenciamento estratégico de recursos hídricos. Esta etapa ressalta a responsabilidade compartilhada no uso da água, auxiliando a empresa a identificar demandas, além de construir e manter um relacionamento com as partes interessadas, gerando confiança e melhoria da imagem e reputação corporativa.";

export class IconValueList extends Component {

	constructor(props) {
		super(props);
		this.state = {
			done: {}
		};
	}

	componentWillMount() {
		this.setState({done: this.props.done});
	}

	componentDidMount() {
		$('.tooltipped').tooltip({ delay: 50 });
	}

	componentWillReceiveProps(nextProps) {
		this.setState({done: nextProps.done});
	}
	
	renderTooltip(props, item) {
		const toReturn = {
			"data-position": "right",
			"data-delay": "50",
		};

		if(props.done[item.id]) { 
			toReturn["data-tooltip"] = "Formulário já respondido.";
			return toReturn;
		} else {
			switch(item.id){
				case "mensuration": return {title: mensurationData};
				case "menagement": return {title: menagementData};
				case "comunication": return {title: comunicationData};
			}
		};
	}

	renderItems() {
		const props = this.props; 
		const disable = (item) => props.done[item.id] ? "disabled tooltipped" : "";
		
		return props.items.map(item =>
			<li 
				key={item.label} 
				className={"item waves-effect flex -al-c " + disable(item)}
				{...this.renderTooltip(props, item)}
			>
				<div className="cointainer-option" onClick={props.clickAction} id={"#"+item.id}>
					<MaterialIcon
						size="gnome"
						type={this.state.done[item.id] ? "check_circle" : "cancel"}
						color={this.state.done[item.id] ? "green" : "red"}
					/> 
					<Text>{item.label}</Text>
				</div>
			</li>
		);
	}

	render() {
		const props = this.props;
		const { items, clickAction } = props;

		return (
			<ul className="icon-value-list" id={props.id}>
				{this.renderItems(props)}
			</ul>
		); 
	}
}


// WEBPACK FOOTER //
// src/molecules/lib/IconValueList.js